import React from 'react';

const Footer = () => {
  return (
    <footer
      className="py-12 transition-colors duration-500"
      style={{ backgroundColor: 'var(--text-primary)', color: 'var(--bg-primary)' }}
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-sm opacity-60" style={{ fontFamily: 'Nohemi, sans-serif' }}>
          &copy; 2025 UKY. Independent Creative Director.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
